import { getBaseUrl } from "../../consts";

export const getAgentConfigUrl = () => `${getBaseUrl()}/v1/platform-configurations/agent`;
